import {
	AUTH_TOKEN,
	AUTHENTICATED,
	SHOW_AUTH_MESSAGE,
	HIDE_AUTH_MESSAGE,
	SIGNOUT_SUCCESS,
	SIGNUP_SUCCESS,
	SHOW_LOADING,
	SIGNIN_WITH_GOOGLE_AUTHENTICATED,
	SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
	SET_USER,
	SIGNIN_SUCCESS
} from '../constants/Auth';

const initState = {
	loading: false,
	message: "",
	showMessage: false,
	redirect: "",
	token: null,
	role: [], // Array of role/permission strings (e.g., ['ROLE_MASTER', 'ROLE_PRODUCTS_VIEW'])
	username: "",
	code: "",
	country: {
		id: null,
		name: "",
		isoCode: "",
	},
	currency: {
		id: null,
		name: "",
		code: "",
		symbol: "",
		rate: 0,
	},
};

const auth = (state = initState, action) => {
	switch (action.type) {
		case SET_USER: {
			return {
				...state,
				username: action.user.username,
				role: action.user.role,
				code: action.user.code,
				country: {
					id: action.user.country.id,
					name: action.user.country.name,
					isoCode: action.user.country.isoCode,
				},
				currency: {
					id: action.user.country.defaultCurrency?.id,
					name: action.user.country.defaultCurrency?.name,
					code: action.user.country.defaultCurrency?.code,
					symbol: action.user.country.defaultCurrency?.symbol,
					rate: action.user.country.defaultCurrency?.rate,
				},
				redirect: '/',
			};
		}
		case AUTHENTICATED:
			return {
				...state,
				loading: false,
				redirect: '/app',
				token: action.token
			}
		case SIGNIN_SUCCESS: {
			return {
				...state,
				redirect: "/app",
				message: "",
				showMessage: false,
			};
		}
		case SHOW_AUTH_MESSAGE:
			return {
				...state,
				message: action.message,
				showMessage: true,
				loading: false
			}
		case HIDE_AUTH_MESSAGE:
			return {
				...state,
				message: '',
				showMessage: false,
			}
		case SIGNOUT_SUCCESS: {
			return {
				...state,
				message: "",
				showMessage: false,
				token: null,
				redirect: "/",
				loading: false,
				role: [],
				username: "",
				code: "",
			};
		}
		case SIGNUP_SUCCESS: {
			return {
				...state,
				loading: false,
				token: action.token
			}
		}
		case SHOW_LOADING: {
			return {
				...state,
				loading: true
			}
		}
		case SIGNIN_WITH_GOOGLE_AUTHENTICATED: {
			return {
				...state,
				loading: false,
				token: action.token
			}
		}
		case SIGNIN_WITH_FACEBOOK_AUTHENTICATED: {
			return {
				...state,
				loading: false,
				token: action.token
			}
		}
		default:
			return state;
	}
}

export default auth
